import { useEffect } from 'react'

let lockCount = 0
let previousOverflow = ''

/**
 * Trava o scroll do body enquanto o componente que chama este hook estiver
 * montado (ex.: um modal aberto). Usa contagem de referências para que
 * múltiplos modais/overlays simultâneos não destravem uns aos outros ao
 * desmontar fora de ordem.
 */
export function useBodyScrollLock(active: boolean = true) {
    useEffect(() => {
        if (!active) return

        if (lockCount === 0) {
            previousOverflow = document.body.style.overflow
            document.body.style.overflow = 'hidden'
        }
        lockCount += 1

        return () => {
            lockCount -= 1
            if (lockCount === 0) {
                document.body.style.overflow = previousOverflow
            }
        }
    }, [active])
}
